const attachmentFilesEquipmentsTypo = {
  label: 'Anexos deste Equipamento',
  noResults: 'Nenhum resultado encontrado'
};

export default attachmentFilesEquipmentsTypo;